import { KeyRound, ShieldCheck, type LucideIcon } from "lucide-react";

/** The personal apps shown in the Security category of the launcher. Each is
 * a separately deployed SPA with its own vault/login; the launcher only links
 * out. Placeholders are deliberately omitted until an app ships. */
export interface PersonalApp {
  key: string;
  name: string;
  summary: string;
  href: string;
  icon: LucideIcon;
}

export function personalApps(): PersonalApp[] {
  return [
    {
      key: "passwords",
      name: "SYLVIQ Passwords",
      summary: "Your encrypted password vault, with optional account sync.",
      href:
        import.meta.env.VITE_PASSWORDS_ORIGIN ?? "https://passwords.sylviq.io",
      icon: KeyRound,
    },
    {
      key: "authenticator",
      name: "SYLVIQ Authenticator",
      summary: "Two-factor codes that stay on your device.",
      href:
        import.meta.env.VITE_AUTHENTICATOR_ORIGIN ??
        "https://authenticator.sylviq.io",
      icon: ShieldCheck,
    },
  ];
}
